import {TRANNSMISSION_TYPE_ID_AUTOMATIC, TRANNSMISSION_TYPE_ID_MANUAL} from '../ads.js'

export const formFieldIds = {
  comments: 'comments',
  makeId: 'makeId',
  modelId: 'modelId',
  bodyTypeDoorsId: 'bodyTypeDoors',
  fuelId: 'fuelId',
  yearId: 'year',
  versionId: 'versionId',
  transmissionTypeId: 'transmissionTypeId',
  hidePhone: 'hidePhone',
  kilometersId: 'km',
  postalCode: 'postalCode',
  price: 'price',
  name: 'name',
  lastName: 'lastName',
  colour: 'colour',
  colourExtra: 'colourExtra',
  email: 'email',
  environmentalLabel: 'environmentalLabel',
  images: 'images',
  notification: 'notification',
  phone: 'phone',
  plate: 'plate',
  plateRegistrationDate: 'plateRegistrationDate',
  privacyCheck: 'privacyCheck',
  province: 'province',
  publishInMA: 'publishInMA',
  recommendedPrice: 'recommendedPrice',
  additionalTitle: 'additionalTitle',
  vehicleStatus: 'vehicleStatus',
  currentPassword: 'currentPassword',
  newPassword: 'newPassword',
  confirmNewPassword: 'confirmNewPassword',
  dataPrivacyCheckbox: 'dataPrivacyCheckbox',
  reliableInfoCheckbox: 'reliableInfoCheckbox',
  // ff_web_seller_show_pta_multitenant
  // TO DO : make PTA coches use plate id
  carPlate: 'carPlate'
}

export const ZIPCODE_ENABLED = true

export const PATTERN_CONSTRAINT_MIN_KILOMETERS_FOR_A_VALID_C2B_APPRAISAL =
  /^(?:1\.00[1-9]|1\.0[1-9]\d|1\.[1-9]\d{2}|[2-9]\.\d{3}|[1-9]\d\.\d{3}|[1-9]\d{2}\.\d{3}|100[1-9]|10[1-9]\d|1[1-9]\d{2}|[2-9]\d{3}|[1-9]\d{4,})$/
    .source

const {
  comments,
  makeId,
  modelId,
  bodyTypeDoorsId,
  fuelId,
  yearId,
  versionId,
  transmissionTypeId,
  hidePhone,
  kilometersId,
  postalCode,
  price,
  name,
  lastName,
  colour,
  email,
  environmentalLabel,
  images,
  phone,
  plate,
  privacyCheck,
  province,
  publishInMA,
  recommendedPrice,
  additionalTitle,
  vehicleStatus,
  currentPassword,
  newPassword,
  confirmNewPassword,
  carPlate
} = formFieldIds

export const fieldNameToTrackingIds = {
  [comments]: {
    field: 'Comments',
    property: 'comentarios'
  },
  [makeId]: {
    field: 'Brand',
    property: 'marca'
  },
  [modelId]: {
    field: 'Model',
    property: 'modelo'
  },
  [bodyTypeDoorsId]: {
    field: 'Body Type',
    property: 'carroceria'
  },
  [fuelId]: {
    field: 'Fuel',
    property: 'combustible'
  },
  [yearId]: {
    field: 'Year',
    property: 'year'
  },
  [versionId]: {
    field: 'Version',
    property: 'version'
  },
  [transmissionTypeId]: {
    field: 'Transmission',
    property: 'cambio'
  },
  [hidePhone]: {
    field: 'Hide Phone',
    property: 'hidePhone'
  },
  [kilometersId]: {
    field: 'Km',
    property: 'kilometros'
  },
  [postalCode]: {
    field: 'Postal Code',
    property: 'codigopostal'
  },
  [price]: {
    field: 'Price',
    property: 'precio'
  },
  [name]: {
    field: 'Name',
    property: 'name'
  },
  [lastName]: {
    field: 'Last Name',
    property: 'lastName'
  },
  [colour]: {
    field: 'Color',
    property: 'color'
  },
  [email]: {
    field: 'Email',
    property: 'email'
  },
  [environmentalLabel]: {
    field: 'Environmental Label',
    property: 'environmentalLabel'
  },
  [images]: {
    field: 'Images',
    property: 'fotos'
  },
  [phone]: {
    field: 'Phone',
    property: 'phone'
  },
  [plate]: {
    field: 'Car Plate',
    property: 'matricula'
  },
  [privacyCheck]: {
    field: 'Privacy Check',
    property: 'privacycheck'
  },
  [province]: {
    field: 'Province',
    property: 'provincia'
  },
  [publishInMA]: {
    field: 'publishInMA',
    property: 'publishInMA'
  },
  [recommendedPrice]: {
    field: 'Recommended Price',
    property: 'recommendedPrice'
  },
  [vehicleStatus]: {
    field: 'Status',
    property: 'status'
  },
  [additionalTitle]: {
    field: 'additionalTitle',
    property: 'additionalTitle'
  },
  [currentPassword]: {
    field: 'currentPassword',
    property: 'currentPassword'
  },
  [newPassword]: {
    field: 'newPassword',
    property: 'newPassword'
  },
  [confirmNewPassword]: {
    field: 'confirmNewPassword',
    property: 'confirmNewPassword'
  },
  // ff_web_seller_show_pta_multitenant
  // Remove when postalCode is fully implemented
  zipCode: {
    field: 'Postal Code',
    property: 'codigopostal'
  },
  // ff_web_seller_show_pta_multitenant
  // TO DO : make PTA coches use plate id
  [carPlate]: {
    field: 'Car Plate',
    property: 'matricula'
  }
}

export const fieldsToTagOnChangeValue = [
  makeId,
  modelId,
  bodyTypeDoorsId,
  colour,
  environmentalLabel,
  fuelId,
  hidePhone,
  yearId,
  versionId,
  transmissionTypeId,
  vehicleStatus,
  publishInMA
]

export const fieldsToTagOnBlurValue = [
  comments,
  email,
  kilometersId,
  name,
  lastName,
  phone,
  plate,
  postalCode,
  price,
  // ff_web_seller_show_pta_multitenant
  // TO DO : make PTA coches use plate id
  carPlate
]

export const numericFieldsToBeFormatted = [kilometersId, phone, postalCode, price]

export const formErrorTypes = {
  fieldError: 'field error',
  serverError: 'server error'
}

export const formFieldContexts = {
  [makeId]: 'makes',
  [modelId]: 'models',
  [bodyTypeDoorsId]: 'bodytypes',
  [fuelId]: 'fuels',
  [yearId]: 'years',
  [versionId]: 'versions',
  [transmissionTypeId]: 'transmissions'
}

// DATALISTS

const transmissionTypes = {
  automatic: {
    ariaLabel: 'FORM.TRANSMISSION.AUTOMATIC_ARIA_LABEL',
    text: 'COMMON.TRANSMISSION_AUTOMATIC',
    value: TRANNSMISSION_TYPE_ID_AUTOMATIC.toString()
  },
  manual: {
    ariaLabel: 'FORM.TRANSMISSION.MANUAL_ARIA_LABEL',
    text: 'COMMON.TRANSMISSION_MANUAL',
    value: TRANNSMISSION_TYPE_ID_MANUAL.toString()
  }
}

export const transmissionsDatalist = [transmissionTypes.automatic, transmissionTypes.manual]

export const reversedTransmissionsDatalist = [transmissionTypes.manual, transmissionTypes.automatic]

const VERY_GOOD = 'VERY_GOOD'

const GOOD = 'GOOD'

const OK = 'OK'

const BAD = 'BAD'

const VERY_BAD = 'VERY_BAD'

export const additionalDataDatalist = [
  {
    value: VERY_GOOD,
    text: 'PUBLISH_AD.STANDALONE.FORM.ADDITIONAL_DATALIST.FLAWLESS'
  },
  {
    value: GOOD,
    text: 'PUBLISH_AD.STANDALONE.FORM.ADDITIONAL_DATALIST.GOOD'
  },
  {
    value: OK,
    text: 'PUBLISH_AD.STANDALONE.FORM.ADDITIONAL_DATALIST.ACCEPTABLE'
  },
  {
    value: BAD,
    text: 'PUBLISH_AD.STANDALONE.FORM.ADDITIONAL_DATALIST.BAD'
  },
  {
    value: VERY_BAD,
    text: 'PUBLISH_AD.STANDALONE.FORM.ADDITIONAL_DATALIST.DAMAGED'
  }
]

export const environmentalLabelDatalist = [
  {
    text: `COMMON.ENVIRONMENTAL_LABELS.0`,
    value: '0'
  },
  {
    text: `COMMON.ENVIRONMENTAL_LABELS.ECO`,
    value: 'ECO'
  },
  {
    text: `COMMON.ENVIRONMENTAL_LABELS.C`,
    value: 'C'
  },
  {
    text: `COMMON.ENVIRONMENTAL_LABELS.B`,
    value: 'B'
  },
  {
    text: `COMMON.ENVIRONMENTAL_LABELS.NO_LABEL`,
    value: 'NO_LABEL'
  }
]

export const colourDatalist = [
  {
    text: 'COMMON.COLOR_YELLOW',
    value: '1'
  },
  {
    text: 'COMMON.COLOR_BLUE',
    value: '2'
  },
  {
    text: 'COMMON.COLOR_BEIGE',
    value: '3'
  },
  {
    text: 'COMMON.COLOR_WHITE',
    value: '4'
  },
  {
    text: 'COMMON.COLOR_GARNET',
    value: '5'
  },
  {
    text: 'COMMON.COLOR_GRAY',
    value: '6'
  },
  {
    text: 'COMMON.COLOR_BROWN',
    value: '7'
  },
  {
    text: 'COMMON.COLOR_ORANGE',
    value: '8'
  },
  {
    text: 'COMMON.COLOR_BLACK',
    value: '9'
  },
  {
    text: 'COMMON.COLOR_RED',
    value: '10'
  },
  {
    text: 'COMMON.COLOR_PINK',
    value: '11'
  },
  {
    text: 'COMMON.COLOR_GREEN',
    value: '12'
  },
  {
    text: 'COMMON.COLOR_PURPLE',
    value: '13'
  }
]

export const formIds = {
  adComplaint: 'mt-ad-complaint-form',
  publishMyAd: 'mt-publish-my-ad-form',
  publishMyAdFieldset: 'mt-publish-my-ad-form-fieldset',
  sellVehicle: 'mt-sell-vehicle-form',
  sellVehicleFieldset: 'mt-sell-vehicle-form-fieldset',
  userContact: 'mt-user-contact-form'
}

// COMMON CONFIG FORMS

export const formTypes = {
  fieldset: 'fieldset',
  group: 'group'
}

// COMMON CONFIG FIELDS

export const defaultInitFieldValue = ''

export const defaultTabIndex = 0

export const displayTypes = {
  block: 'block',
  buttonInline: 'button-inline',
  checkbox: 'checkbox',
  dropdown: 'dropdown',
  dropdownAutosuggest: 'dropdown-autosuggest',
  email: 'email',
  money: 'money',
  multiline: 'multiline',
  numeric: 'numeric',
  switch: 'switch'
}

export const inputTypes = {
  numeric: 'numeric',
  picker: 'picker',
  text: 'text'
}

export const patterns = {
  numbersOnly: '\\d*'
}
